import React, { useEffect, useState } from "react";
import { MultiSelect } from "react-multi-select-component";
import Dropdown from "../../components/Dropdown";
import "bootstrap/dist/css/bootstrap.min.css";
// At the top of your CustomDashboard.js file:
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// Import the specific icon object (faFilePdf)
import { faEye, faFileExcel, faFilePdf } from '@fortawesome/free-regular-svg-icons';
import { faRefresh, faSearch } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";


const Dashboard = () => {
  // -------------------
  // AUTO YEARS
  // -------------------
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 6 }, (_, i) => currentYear - i).map(
    (y) => ({ label: String(y), value: y })
  );

  // -------------------
  // MONTHS
  // -------------------
  const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December",
  ].map((m, i) => ({ label: m, value: (i + 1).toString().padStart(2, "0") }));

  // const employees = [
  //   { label: "John", value: 1 },
  //   { label: "Kartik", value: 2 },
  //   { label: "Rahul", value: 3 },
  // ];

  const [employees, setEmployees] = useState([]);
  const [selectedNames, setSelectedNames] = useState([]);
  const [selectedMonths, setSelectedMonths] = useState([]);

  const [rangeType, setRangeType] = useState("year");
  const [dynamicValue, setDynamicValue] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [filter, setFilter] = useState(
    {
      "employees": [''],
      "rangeType": "year",
      "year": 2025,
      "months": null,
      "startDate": null,
      "endDate": null
    })
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 5;
  const totalPages = Math.ceil(tableData.length / pageSize) || 1;
  const paginatedData = tableData.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  // Normalize dropdown data
  const normalizeOption = (opt) => {
    if (!opt) return null;
    if (typeof opt === "object") return opt;
    return { label: String(opt), value: opt };
  };

  const handleRangeTypeChange = (e) => {
    const normalized = normalizeOption(e);
    setRangeType(normalized?.value || "year");

    setDynamicValue(null);
    setSelectedMonths([]);
    setStartDate("");
    setEndDate("");
  };

  const handleDynamicChange = (e) => {
    setDynamicValue(normalizeOption(e));
  };

  // -----------------------
  // EXPORT EXCEL
  // -----------------------
  const exportExcel = (data) => {
    if (!data || data.length === 0) return alert("No data to export.");

    let csv =
      Object.keys(data[0]).join(",") +
      "\n" +
      data.map((row) => Object.values(row).join(",")).join("\n");

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "report.csv";
    link.click();
  };

  // -----------------------
  // EXPORT PDF
  // -----------------------
  const exportPDF = (data) => {
    if (!data || data.length === 0) return alert("No data to export.");

    const html = `
      <html>
      <head>
        <title>Report</title>
        <style>
          table { width: 100%; border-collapse: collapse; }
          th, td { border: 1px solid #555; padding: 8px; font-size: 12px; }
          th { background: #eee; }
        </style>
      </head>
      <body>
        <h2>Report</h2>
        <table>
          <thead>
            <tr>${Object.keys(data[0]).map((h) => `<th>${h}</th>`).join("")}</tr>
          </thead>
          <tbody>
            ${data
        .map(
          (row) =>
            `<tr>${Object.values(row)
              .map((v) => `<td>${v}</td>`)
              .join("")}</tr>`
        )
        .join("")}
          </tbody>
        </table>
      </body>
      </html>
    `;

    const newWindow = window.open("", "_blank");
    newWindow.document.write(html);
    newWindow.print();
  };

  // -------------------
  // VALIDATION
  // -------------------
  const validateInputs = () => {
    if (selectedNames.length === 0) {
      alert("Please select at least one Employee.");
      return false;
    }

    if (rangeType === "year" && !dynamicValue) {
      alert("Please select a Year.");
      return false;
    }

    if (rangeType === "month") {
      if (!dynamicValue) {
        alert("Please select a Year.");
        return false;
      }
      if (selectedMonths.length === 0) {
        alert("Please select Month(s).");
        return false;
      }
    }

    if (rangeType === "custom") {
      if (!startDate) return alert("Please select Start Date.");
      if (!endDate) return alert("Please select End Date.");
      if (startDate > endDate) return alert("End must be greater.");
    }

    return true;
  };

  const resetData = () => {
    // 1. Clear Multi-Selects
    setSelectedNames([]);
    setSelectedMonths([]);

    // 2. Reset Range/Date Inputs
    setRangeType("year");
    setDynamicValue(null);
    setStartDate("");
    setEndDate("");

    // 3. Clear Results
    setTableData([]);
    setCurrentPage(1);
  };
  // -------------------
  // FETCH DATA
  // -------------------
  // const searchData = () => {
  //   if (!validateInputs()) return;

  //   setLoading(true);

  //   // Api Call

  //   //Api payload // empid , startDate  EndDate
  //   const sample = [
  //     { id: 1, name: "John", date: "2024-01-10", amount: 100 },
  //     { id: 2, name: "Kartik", date: "2024-02-12", amount: 200 },
  //     { id: 3, name: "Rahul", date: "2024-03-15", amount: 300 },
  //     { id: 4, name: "John", date: "2024-04-18", amount: 150 },
  //   ];

  //   setTimeout(() => {
  //     let filtered = sample.filter((r) =>
  //       selectedNames.map((e) => e.label).includes(r.name)
  //     );

  //     if (rangeType === "month") {
  //       filtered = filtered.filter((r) =>
  //         selectedMonths.map((m) => m.value).includes(r.date.substring(5, 7))
  //       );
  //     }
  //    console.log("filtered",filtered)
  //     setTableData(filtered);
  //     setCurrentPage(1);
  //     setLoading(false);
  //   }, 600);
  // };

  const searchData = async () => {
    if (!validateInputs()) return;

    setLoading(true);

    // const empIds = selectedNames.map((e) => e.value);
    const empIds = selectedNames.map(e => e.value).join(",");


    let payload = {
      empIds: empIds,
      //rangeType: rangeType,
      in_year: null,
      months_ids: null,
      startDate: null,
      endDate: null,
    };

  //   {
  //   empIds: "118557,71041",
  //   months_ids: "",
  //   in_year: "",
  //   startDate:"2025-11-01",
  //   endDate:"2025-11-30"
  // }

    if (rangeType === "year") {
      payload.in_year = dynamicValue?.value;
    }

    if (rangeType === "month") {
      payload.in_year = dynamicValue?.value;
      payload.months_ids = selectedMonths.map((m) => m.value);
    }

    if (rangeType === "custom") {
      payload.startDate = startDate;
      payload.endDate = endDate;
    }

    //console.log("Payload:", payload);

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/emp/state`,payload);


      //console.log("API Response:", response.data);
      //setTableData(response.data?.data || []);
      let apiData = [];

if (Array.isArray(response.data)) {
  apiData = response.data;
} else if (Array.isArray(response.data.data)) {
  apiData = response.data.data;
} else if (Array.isArray(response.data.result)) {
  apiData = response.data.result;
} else {
  console.error("Unknown API format:", response.data);
}

setTableData(apiData);


      setCurrentPage(1);
    } catch (error) {
      console.error("API Error:", error);
      alert("Something went wrong while fetching data!");
    } finally {
      setLoading(false);
    }
  };

  const fetchEmployees = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/users/role2`);

    //debugger
     //console.log("API Response:", response.data); // 👈 CHECK THIS IN CONSOLE

    let users = [];

    users = response.data.users;

    const empId = localStorage.getItem("empId")

    const formatted = (empId == 1)
  ? users.map((u) => ({
      label: u.u_name,
      value: u.empid,
    }))
  : users
      .filter((u) => u.empid == empId)
      .map((u) => ({
        label: u.u_name,
        value: u.empid,
      }));


    setEmployees(formatted);

  } catch (error) {
    //console.log(error);
    console.error("Error fetching employees:", error);
  }
};



  //
  // Add this function inside the Dashboard component,
  // for example, before the searchData function.


  // Generate dynamic headers
  const generateHeaders = () =>
    tableData.length > 0 ? Object.keys(tableData[0]) : [];

  // -------------------
  // RENDER UI
  // -------------------

  useEffect(() => {
fetchEmployees();
  }, [])
  return (
    <div className="container mt-4">
      <div className="card p-3 shadow-sm">
        <h4 className="fw-bold mb-3">Search Filters</h4>

        <div className="row g-3 align-items-end">
  
  <div className="col-md-3 mb-2">
    <label className="form-label fw-bold">Employee *</label>
    <MultiSelect
      options={employees}
      value={selectedNames}
      onChange={setSelectedNames}
      labelledBy="Select Employee"
    />
  </div>

  <div className="col-md-3">
    <Dropdown
      label="Range Type *"
      value={rangeType}
      onChange={handleRangeTypeChange}
      options={[
        { label: "Year", value: "year" },
        { label: "Month", value: "month" },
        { label: "Custom", value: "custom" },
      ]}
    />
  </div>

  <div className={rangeType === "custom" ? "col-md-4" : "col-md-3"}>
    {rangeType === "year" && (
      <Dropdown
        label="Select Year *"
        value={dynamicValue}
        onChange={handleDynamicChange}
        options={years}
      />
    )}

    {rangeType === "month" && (
      <div className="row g-2">
        <div className="col-md-6">
          <Dropdown
            label="Select Year *"
            value={dynamicValue}
            onChange={handleDynamicChange}
            options={years}
          />
        </div>

        <div className="col-md-6">
          <label className="form-label fw-bold">Select Month *</label>
          <MultiSelect
            options={months}
            value={selectedMonths}
            onChange={setSelectedMonths}
            labelledBy="Month"
          />
        </div>
      </div>
    )}

    {rangeType === "custom" && (
      <div className="row g-2">
        <div className="col-md-6 mt-3">
          <label className="small fw-bold">Start Date *</label>
          <input
            type="date"
            className="form-control"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </div>

        <div className="col-md-6 mt-3">
          <label className="small fw-bold">End Date *</label>
          <input
            type="date"
            className="form-control"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>
      </div>
    )}
  </div>

  <div className="col-md-2 d-flex justify-content-center mb-2">
    <button
      className="btn btn-primary w-50 me-2 btn-md"
      onClick={searchData}
      disabled={loading}
    >
      <FontAwesomeIcon className="fa-lg me-1" icon={faSearch} />
    </button>

    <button
      className="btn btn-secondary w-50 btn-md"
      onClick={resetData}
      disabled={loading}
    >
      <FontAwesomeIcon className="fa-lg me-1" icon={faRefresh} />
    </button>
  </div>
</div>

      </div>

      {/* TABLE */}
{tableData.length > 0 && (
  <div className="card mt-4 p-3 shadow-sm">

    {/* ------- GRID HEADER WITH EXPORT BUTTONS ------- */}
    <div className="d-flex justify-content-between align-items-center mb-3">
      <h5 className="fw-bold">Tickets Records</h5>

      <div>
        <button
          className="btn btn-success btn-sm me-2"
          onClick={() => exportExcel(tableData)}
          disabled={tableData.length === 0}
        >
          <FontAwesomeIcon className="fa-lg me-1" icon={faFileExcel} />
          Export Excel
        </button>

        <button
          className="btn btn-danger btn-sm"
          onClick={() => exportPDF(tableData)}
          disabled={tableData.length === 0}
        >
          <FontAwesomeIcon className="fa-lg me-1" icon={faFilePdf} />
          Export PDF
        </button>
      </div>
    </div>

    {/* ------- GRID TABLE ------- */}
    <div style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
      <table className="table table-bordered table-striped mt-2">
        <thead className="table-dark">
          <tr>
            {Object.keys(tableData[0]).map((col, index) => (
              <th key={index}>
                {col.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())}
              </th>
            ))}
            <th
             style={{
                  position: "sticky",
                  right: 0,
                  background: "dark",
                  zIndex: 4,
                }}
            >
              ACTION</th>
          </tr>
        </thead>

        <tbody>
          {tableData.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {Object.keys(row).map((col, colIndex) => (
                <td key={colIndex}>{row[col]}</td>
              ))}
              <td
              style={{
                  position: "sticky",
                  right: 0,
                  background: "white",
                  zIndex: 4,
                }}
              >
                <button
                  className="btn btn-sm btn-primary"
                  onClick={() => console.log("View Row:", row)}
                  
                >
                  <FontAwesomeIcon icon={faEye} />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>

  </div>
)}





    </div>
  );
};

export default Dashboard;
